module.exports = __webpack_public_path__ + "static/img/zhengchang.2577814.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhengchang.jpg
// module id = CTyx
// module chunks = 1